import React from 'react';
import "../styles/highlight.scss";

const Highlight = () => {
  return (
    <div className='highlight'>
        <h1>Order from the best!</h1>
    </div>
  )
}

export default Highlight